import * as d3 from 'd3';

export const CIRCLE_DATA = 'CIRCLE_DATA';
export const BUBBLEUSERID = 'BUBBLEUSERID';
export const MENU_STATUS = 'MENU_STATUS';

export function bubble_userid(userid){
  const uid = userid === undefined ? 'average' : userid; 
  return {
    type:BUBBLEUSERID,
    payload: uid
  }
}

export function circleData(value){
  const valuerange = value.reduce((a, b) => a + b, 0) + 5 
  const data = d3.range(valuerange).map(function(d,idx){
      return {r: Math.floor(Math.random() * 18 + 2),id: 'user' + idx};
  });
  const datacustom = {nodes:data}
  return {
    type:CIRCLE_DATA,
    payload: datacustom
  }
}

export function menuStatus(mStatus){
  const status = mStatus === undefined ? false : mStatus; 
  return {
    type:MENU_STATUS,
    payload: status
  }
}


// WEBPACK FOOTER //
// ./src/actions/fetch_topusers.js